/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {revokeWebLoginTokens} from '../api'

export const useMutationRevokeWebLoginTokens = createReactQueryMutationHook('revokeWebLoginTokens', revokeWebLoginTokens)
